import { useState, useEffect } from "react";
import { getAnnouncement, getFeatureFlags } from "../utils/adminStore";

export function AnnouncementBar() {
  const [announcement, setAnnouncement] = useState(getAnnouncement());
  const [visible, setVisible] = useState(true);
  const [enabled, setEnabled] = useState(getFeatureFlags().enableAnnouncementBar);

  useEffect(() => {
    const sync = () => {
      setAnnouncement(getAnnouncement());
      setEnabled(getFeatureFlags().enableAnnouncementBar);
    };
    window.addEventListener("radiece_admin_update", sync);
    return () => window.removeEventListener("radiece_admin_update", sync);
  }, []);

  if (!enabled || !visible || !announcement) return null;

  return (
    <aside aria-label="Company Announcement" className="no-print bg-[#080d16] border-b border-white/10 text-white py-2 px-4 text-xs relative z-40 transition-colors">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5 overflow-hidden">
          <span className="flex h-2 w-2 relative shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
          </span>
          <a
            href="/news"
            className="truncate text-slate-200 hover:text-primary transition-colors font-medium tracking-wide"
          >
            {announcement}
          </a>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <a
            href="/news"
            className="hidden sm:inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-primary hover:text-sky-300"
          >
            View Newsfeed →
          </a>
          <button
            onClick={() => setVisible(false)}
            aria-label="Dismiss Announcement"
            className="text-slate-400 hover:text-white p-0.5 cursor-pointer text-xs leading-none"
          >
            ✕
          </button>
        </div>
      </div>
    </aside>
  );
}
